import React from 'react';
import $ from 'jquery';
import {CurrencyRenderer, CurrencyRendererRed, NumberRenderer, GetParams, DisplayTimeEnd, DisplayTimeRange, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class TopAcctTbl extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			date: null,
			start: null,
			end: null,
			firm: null,
			acct: null,
			sybl: null,

			needToUpdate: false,
			startTS: null,
			endTS: null,
			updateCount: 0
		};

		this.table = null
	}

	static getDerivedStateFromProps(props, state) {
		let obj = {}
		if(state.date !== props.date || state.start !== props.start || state.end !== props.end || state.firm !== props.firm
			|| state.acct !== props.acct || state.sybl !== props.sybl){
			obj = {...props, needToUpdate: true}
		}
		if(state.startTS !== props.startTS || state.endTS !== props.endTS){
			obj.startTS = props.startTS
			obj.endTS = props.endTS
		}
		if(state.updateCount !== props.updateCount){
			obj.updateCount = props.updateCount
			obj.needToUpdate = true
		}
		return obj;
	}

	componentDidUpdate(props, state){
		if(this.state.needToUpdate){
			let self = this
			this.setState({needToUpdate: false}, function(){
				if(self.table !== null){
					self.table.ajax.url(MWBaseURL() + "top_accounts?" + GetParams(self.state)).load()
					self.setEvents()
				}
			})
		}
	}

	setEvents(){
		let self = this
		$("#"+self.state.id+" tbody").off()

		$("#"+self.state.id+" tbody").on("click", "tr .filterable", function(){
			let row = self.table.row(this).data()
			self.state.refilter({
				selectedAcct: [row.account],
				selectedAcctName: row.name
			})
		});
	}

	async componentDidMount() {
		let self = this
		const apiClient = createApiClient();
		this.table = $('#'+self.state.id).DataTable({
			scrollX: true,
			responsive: true,
			paging: false,
			info: false,
			filter: false,
			ajax: await apiClient.getDataTableAjaxSettings(MWBaseURL()+"top_accounts?"+GetParams(self.state)),
			ordering: false,
			columns: [
				{title: "Traders", data: "name", className: "clickable filterable"},
				{title: "Group", data: "group_name"},
				{title: "Net P&L", data: "endpnl", render: CurrencyRendererRed, className: "text-right"},
				{title: "MV",  data: "endmv", render: CurrencyRenderer, className: "text-right"},
				{title: "Volume", data: "endvolume", render: NumberRenderer, className: "text-right"},
				{title: "Δ Net P&L", data: "pnl", render: CurrencyRendererRed, className: "text-right"},
				{title: "Δ MV", data: "mv", render: CurrencyRenderer, className: "text-right"}
			]
		});
		self.setEvents()
	}

	render(){
		return (
			<div>
			<h5>Top/Bottom <a href="/#" onClick={() => this.state.refilter({view: 2, selectedTag: [], selectedSybl: [], selectedx0: null, selectedx1: null, selectedRows: []})}>Traders</a></h5>
			<table id={this.state.id} className="display compact nowrap groupedTbl groupedHLTbl" width="100%">
					<thead>
						<tr>
							<th colSpan="1" rowSpan="2"></th>
							<th colSpan="1" rowSpan="2"></th>
							<th className="text-center" colSpan="3"><DisplayTimeEnd end={this.state.end} startTS={this.state.startTS} endTS={this.state.endTS}/></th>
							<th className="text-center verticalTableSeparator" colSpan="2"><DisplayTimeRange start={this.state.start} end={this.state.end} startTS={this.state.startTS} endTS={this.state.endTS}/></th>
						</tr>
						<tr>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
							<th></th>
						</tr>
					</thead>
				</table>
			</div>
		)
	}
}


export default TopAcctTbl;